export const FILTER = {
  PRE_ORDER: 'PRE_ORDER',
  BESTSELLER: 'BESTSELLER',
  GOODS_STATUS: 'GOODS_STATUS',
  // disable drinks filter
  // DRINKS: 'DRINKS',
};

export const FILTER_STRING = {
  [FILTER.PRE_ORDER]: '午餐訂便當',
  [FILTER.BESTSELLER]: '名品預訂',
  [FILTER.GOODS_STATUS]: '機台現貨',
  [FILTER.DRINKS]: '下午喝飲料',
};

export const DATA_SOURCE = {
  MENU: 'MENU',
  DAILY_FRESH_PRE_ORDER: 'DAILY_FRESH_PRE_ORDER',
  ONLINE_SHOP: 'ONLINE_SHOP',
};

export const PRODUCT_GROUP_PROPERTY = {
  [DATA_SOURCE.MENU]: 'providerId',
  [DATA_SOURCE.DAILY_FRESH_PRE_ORDER]: 'providerId',
  [DATA_SOURCE.ONLINE_SHOP]: 'onlineShopId',
};

export const SUGAR_LEVEL = {
  NO: 'NO',
  NORMAL: 'NORMAL',
};

export const SUGAR_LEVEL_STRING = {
  [SUGAR_LEVEL.NO]: '無糖',
  [SUGAR_LEVEL.NORMAL]: '黃金比例',
};

export const ICE_LEVEL = {
  NO: 'NO',
};

export const ICE_LEVEL_STRING = {
  [ICE_LEVEL.NO]: '去冰',
};

export const OPTION_KEY_STRING_MAP = {
  sugarLevel: SUGAR_LEVEL_STRING,
  iceLevel: ICE_LEVEL_STRING,
};

export default {};
